"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var container = function container(primaryColor) {
  return /*#__PURE__*/(0, _emotion.css)("display:grid;grid-template-columns:1fr 1fr 1fr;grid-gap:10px;align-items:center;font-family:'Open Sans',-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Noto Sans','Ubuntu','Droid Sans','Helvetica Neue',sans-serif;@media (max-width:576px){grid-template-columns:1fr;}.card-container{padding:5px;display:grid;grid-gap:10px;align-items:center;.card{height:110px;padding:20px 30px;cursor:pointer;box-sizing:border-box;display:grid;grid-template-columns:auto auto;height:110px;overflow:hidden;align-items:center;border-right:3px solid transparent;border-radius:4px;box-shadow:0 0px 2px 0 rgba(220,220,220,1);transition:all ease 0.2s;.title{margin:0;color:#262626;font-weight:400;}.subtitle{height:0;overflow:hidden;margin:0;white-space:nowrap;max-width:200px;text-overflow:ellipsis;color:", primaryColor, ";*{color:", primaryColor, ";}@media (max-width:576px){height:100%;}}&:hover{border-right-color:", primaryColor, ";box-shadow:0 1px 4px 0 rgba(220,220,220,1);.subtitle{height:100%;margin-top:5px;}}}.card.with-icon .icon{text-align:left;@media (max-width:576px){text-align:right;}}.card.with-icon .content{text-align:right;@media (max-width:576px){grid-row:1;text-align:left;}}.card.right-icon.with-icon .icon{text-align:right;}.card.right-icon.with-icon .content{text-align:left;}.card.right-icon{border-left:3px solid transparent;border-right:0;}.card.right-icon:hover{border-left-color:", primaryColor, ";}.card.row-reverse{flex-direction:row-reverse;}}");
};

var Context = _react.default.createContext(null);

var InfoCards = /*#__PURE__*/function (_React$Component) {
  function InfoCards() {
    var _temp, _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_temp = _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this, _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      selectedItem: null
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mouseEnter", function (item) {
      _this.setState({
        selectedItem: item
      });
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mouseLeave", function () {
      _this.setState({
        selectedItem: null
      });
    }), _temp) || _assertThisInitialized(_this);
  }

  var _proto = InfoCards.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = _objectWithoutProperties(_this$props, ["children"]);

    var selectedItem = this.state.selectedItem;
    return _react.default.createElement("div", {
      className: container(props.primaryColor)
    }, _react.default.createElement(Context.Provider, {
      value: {
        selectedItem: selectedItem,
        onMouseEnter: this.mouseEnter,
        onMouseLeave: this.mouseLeave
      }
    }, _react.default.Children.map(this.props.children, function (child) {
      return _react.default.cloneElement(child, _extends({}, props));
    })));
  };

  _inheritsLoose(InfoCards, _React$Component);

  return InfoCards;
}(_react.default.Component);

_defineProperty(InfoCards, "Card", function (props) {
  return _react.default.createElement(Context.Consumer, null, function (_ref) {
    var _onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave;
    return _react.default.createElement("div", {
      className: "card " + (props.iconAtRight ? 'right-icon' : '') + " " + (props.icon ? 'with-icon' : ''),
      onMouseEnter: function onMouseEnter() {
        return _onMouseEnter(props);
      },
      onMouseLeave: onMouseLeave
    }, props.icon && !props.iconAtRight && _react.default.createElement("div", {
      className: "icon"
    }, props.icon), _react.default.createElement("div", {
      className: "content"
    }, _react.default.createElement("h3", {
      className: "title"
    }, props.title), props.subtitle && _react.default.createElement("p", {
      className: "subtitle"
    }, props.subtitle)), props.icon && props.iconAtRight && _react.default.createElement("div", {
      className: "icon"
    }, props.icon));
  });
});

_defineProperty(InfoCards, "Section", function (_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return _react.default.createElement("div", {
    className: "card-container"
  }, _react.default.Children.map(children, function (child) {
    return _react.default.cloneElement(child, _extends({}, props));
  }));
});

_defineProperty(InfoCards, "MainSection", function (props) {
  return _react.default.createElement(Context.Consumer, null, function (_ref3) {
    var selectedItem = _ref3.selectedItem;
    return props.children(selectedItem);
  });
});

InfoCards.defaultProps = {
  primaryColor: '#225dd4'
};
InfoCards.propTypes = {
  children: _propTypes.node,
  primaryColor: _propTypes.string
};
var _default = InfoCards;
exports.default = _default;